import React, { useState } from "react";
import { Link } from "react-router-dom";
import { RouterConstant } from "../../routers/index";
import { Action, Loader } from "../../assets/images/index";
import BackButton from "../back-button";
import MathExpressionNew from "../../components/common/mathjax"; // Adjust the import path as needed
import { logout } from "../../utils/authUtils"; // Import the logout function
import "./chat-header.scss";

interface ChatHeaderProps {
  chatHeading: string;
  onBackClick: () => void;
  hideBack?: boolean;
  hideLogoutLogo?: boolean;
  currentIndex?: number;
  totalExercises?: number;
  isLoading?: boolean;
}

export default function Index({
  chatHeading, onBackClick, hideBack = false, currentIndex, totalExercises, hideLogoutLogo = false, isLoading = false
}: ChatHeaderProps) {
  const { ROUTERS_PATH } = RouterConstant;
  const [showTooltip, setShowTooltip] = useState(false);

  const handleLogout = () => {
    logout(); // Call the logout function
  };

  return (
    <div className="chat-page-header">
      <div className="chat-page-header-inner">
        {!hideBack && (
          <div>
            <BackButton onClickBack={onBackClick} />
          </div>
        )}
        <div
          className="chat-header-title-container"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <h1 className="chat-page-header-title">
            <MathExpressionNew content={chatHeading} />
          </h1>
          {showTooltip && (
            <div className="chat-header-tooltip">
              <MathExpressionNew content={chatHeading} />
            </div>
          )}
        </div>
      </div>
      {isLoading ? (
        <div className="exercise-counter loaderBlock">
          <img src={Loader} alt="Loading" />
        </div>
      ) : (
        typeof currentIndex === "number" &&
        typeof totalExercises === "number" && (
          <div className="exercise-counter">
            <span>{currentIndex}</span>/{totalExercises}
          </div>
        )
      )}
    </div>
  );
}